module.exports = __webpack_public_path__ + "img/check.0064dd9e.svg";